import getIsCapitalDepositStepRequired from '../getIsCapitalDepositStepRequired';
import useVerificationQuery from '../useVerificationQuery';
import { ContextSpecificStepStatus } from './types';

const getCapitalDepositStepStatus = (
  verificationQueryResult: ReturnType<typeof useVerificationQuery>,
): ContextSpecificStepStatus => {
  const { cachedShowCapitalDepositStep, data } = verificationQueryResult;
  if (data === undefined) {
    throw new Error('Data should be loaded by this point');
  }
  const isCapitalDepositStepRequired = getIsCapitalDepositStepRequired(data);
  const showCapitalDepositStep =
    isCapitalDepositStepRequired === true ||
    cachedShowCapitalDepositStep === true;
  if (!showCapitalDepositStep) {
    return 'not-shown';
  }
  if (isCapitalDepositStepRequired) {
    return 'waiting';
  }
  return 'pending';
};

export default getCapitalDepositStepStatus;
